export class ElementConfig {
  public options: Array<{ id: string, value: any, language: string, originalId: string }> = [];
  public question: string | { [key: string]: string } = '';
  public isRequired: boolean = false;
  public defaultValue: string = '';
  // TODO: define more precise?
  public translations: null | { [key: string]: { [key: string]: string } } = null;

  constructor(data: any) {
    if (this.optionsValid(data.options)) {
      this.options = data.options;
    }
    this.question = data.question;
    this.isRequired = data.isRequired;
    this.defaultValue = data.defaultValue;
    this.translations = data.translations;
  }

  private optionsValid(options: any): boolean {
    return options && Array.isArray(options) && options.length > 0 && options[0].id !== undefined;
  }
}
